module.exports = __webpack_public_path__ + "img/westmount_square.78b4606c.webp";